import { render, staticRenderFns } from "./iframeBase.vue?vue&type=template&id=39a716b4&scoped=true&"
import script from "./iframeBase.vue?vue&type=script&lang=js&"
export * from "./iframeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a716b4",
  null
  
)

export default component.exports